<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { STRETCH_MARKS_OPTIONS, findStretchMarksOption, type StretchMarksValue } from '../../types/stretch-marks'

    export let label: string
    export let data: Record<string, any>
    export let value: StretchMarksValue = null
    export let required = false
    export let readOnly = false

    function select(key: string) {
        if (readOnly) return
        value = key
    }

    $: selectedOption = findStretchMarksOption(value)
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="stretch-scale">
        {#each STRETCH_MARKS_OPTIONS as option (option.key)}
            <button
                type="button"
                class="stretch-row"
                class:selected={value === option.key}
                disabled={readOnly}
                on:click={() => select(option.key)}
            >
                <span class="stretch-label">
                    {option.label}
                    <span class="stretch-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <span class="stretch-desc">{option.description}</span>
            </button>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .stretch-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .stretch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }
    .stretch-row:disabled {
        cursor: not-allowed;
    }
    .stretch-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .stretch-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .stretch-row.selected .stretch-label {
        color: #1f2937;
    }
    .stretch-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .stretch-row.selected .stretch-desc {
        color: #1f2937;
    }
    .stretch-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .stretch-row.selected .stretch-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
